export const deleteChannelFailed = {
  title:
    'Unable to proceed. Please contact the Online Merchant Success Team for assistance.',
};
